<template>
  <div :class="{ collapsed: collapsed }" class="collapsible" :style="cssProps">
    <div @click.stop.prevent="toggle" class="toggle">
      <slot :collapsed="collapsed" name="toggle"></slot>
    </div>
    <transition name="expand" @after-enter="calcHeight" @before-leave="calcHeight" >
      <slot :collapsed="collapsed" name="content" v-if="!collapsed"></slot>
    </transition>
  </div>
</template>

<script>
export default {
  name: "Collapsible",
  data() {
    return {
      collapsed: true,
      collapsingHeight: 400,
    };
  },
  props: {
    isCollapsed: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isCollapsed: {
      immediate: true,
      handler(collapsed) {
        this.collapsed = collapsed;
      },
    },
  },
  computed: {
    cssProps() {
      return { "--collapse-height": this.collapsingHeight + "px" };
    },
  },
  methods: {
    toggle() {
      if( this.disabled ) return
      this.collapsed = !this.collapsed;
      this.$emit("toggled", this.collapsed);
    },

    calcHeight() {
      this.collapsingHeight = this.$slots.content[0].elm.clientHeight
    },

    // closePanel(){
    // 	this.collapsed = true;
    // },
    // openPanel(){
    // 	this.collapsed = false;
    // }
  },
  // mounted() { //Moved to sentenceEditPopover for easy toggling
  // 	EventBus.$on('close_preview', this.closePanel)
  // 	EventBus.$on('open_preview', this.openPanel)
  // },
};
</script>

<style lang="less">
.collapsible {
  .toggle {
    cursor: pointer;
  }
}
.expand-enter-to,
.expand-leave {
  height: var(--collapse-height);
  // max-height: 1000px;
  // transform: scaleY(1);
  // opacity: 1;
}
.expand-enter,
.expand-leave-to {
  height: 0px;
  // max-height: 0px;
  // transform: scaleY(0);
  // opacity: 0;
}
.expand-enter-active,
.expand-leave-active {
  transform-origin: top;
  overflow: hidden;
  transition: height 0.1s ease;
}
</style>
